// Polyfills for browser environment
if (typeof window !== 'undefined') {
    // Add process polyfill
    if (!window.process) {
      window.process = { env: { NODE_ENV: 'production' } } as any;
    }
    
    // Add global polyfill if needed
    if (!window.global) {
      window.global = window;
    }
  }
  
  export {}; 